import { render, staticRenderFns } from "./HandleOrdersSidebar.vue?vue&type=template&id=49a1b08d&scoped=true&"
import script from "./HandleOrdersSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleOrdersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleOrdersSidebar.vue?vue&type=style&index=0&id=49a1b08d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a1b08d",
  null
  
)

export default component.exports